import * as React from 'react';
import { useDispatch } from 'react-redux';

import { cancelEditNote, IUpdateNoteParams, updateNote } from '../../actions/favoriteEntities/notes';
import { CommentForm } from '../../components/CommentForm';
import { useFavoritesUxfeedbackCampaign } from '../../hooks/uxfeedback';

interface ICommentFormContainerProps {
  entityId: number;
  isFetching: boolean;
  comment?: string | null;
}

export const CommentFormContainer = ({ entityId, comment, isFetching }: ICommentFormContainerProps) => {
  const dispatch = useDispatch();
  const { sendFavoritesUxfeedbackCampaign } = useFavoritesUxfeedbackCampaign();

  const handleSubmitComment = React.useCallback(
    (params: IUpdateNoteParams) => {
      dispatch(updateNote({ entityId: params.entityId, comment: params.comment }));
      sendFavoritesUxfeedbackCampaign();
    },
    [dispatch, sendFavoritesUxfeedbackCampaign],
  );

  const handleCancelComment = React.useCallback((entityId: number) => dispatch(cancelEditNote(entityId)), [dispatch]);

  return (
    <CommentForm
      comment={comment}
      entityId={entityId}
      isFetching={isFetching}
      onSubmitComment={handleSubmitComment}
      onCancelComment={handleCancelComment}
    />
  );
};
